'use client';

import LanguageSelector from '../i18n/LanguageSelector';
import { changeLanguage, SUPPORTED_LANGUGES } from '@altus-ui/i18n';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import logo from '../../assets/images/ciclogo.svg';
import Image from 'next/image';
import { appConfig } from '../../env/client';
import { useRouter } from 'next/navigation';
import { PUBLICSITE_COOKIE_KEY_LOCALE } from '../common/constants';

export default function Header() {
  const {
    i18nHelper: { t },
    language
  } = useGlobalClientContext();
  const router = useRouter();
  const onChangeLang = (lang: SUPPORTED_LANGUGES) => {
    changeLanguage(
      lang,
      {
        domain: appConfig().PUBLIC_SITE_COOKIE_DOMAIN,
        expires: 30
      },
      true,
      PUBLICSITE_COOKIE_KEY_LOCALE
    );
  };

  const loginHref = `${appConfig().NEXT_PUBLIC_URL}/signin`;
  const interestHref = `/talk-to-expert`;
  const productHref = `/products`;
  const pricingHref = `/pricing`;
  const solutionsHref = `/solutions`;
  const aboutHref = `/about`;

  return (
    <nav className="bg-white fixed w-full z-20 top-0 start-0 border-b-[1px] border-solid border-gray-100 flex items-center justify-center overflow-visible">
      <div className="max-w-screen-xl flex w-[1280px] h-[68px] items-center justify-between shrink-0 grow-0">
        <div className="flex flex-row items-center justify-between gap-[40px]">
          <a
            href="/"
            className="flex items-center space-x-3 rtl:space-x-reverse">
            <Image src={logo} alt="Logo" />
          </a>
          <div className="border-l-solid gap-4xl font-semibold text-md leading-sm text-gray-700 flex items-center">
            <a href={productHref} className='text-gray-700 hover:cursor-pointer hover:no-underline'>
              {t('public.site.top.menu.products', {})}
            </a>
            <a href={solutionsHref} className='text-gray-700 hover:cursor-pointer hover:no-underline'>
              {t('public.site.solution.title', {})}
            </a>
            <a href={pricingHref} className='text-gray-700 hover:cursor-pointer hover:no-underline'>
              {t('public.site.top.menu.pricing', {})}
            </a>
          </div>
        </div>
        <div className="flex flex-row items-center justify-between gap-3xl w-fit">
          <a
            href={loginHref}
            className="font-semibold text-md leading-sm text-gray-700 hover:cursor-pointer hover:no-underline">
            {t('login.capitalize', {})}
          </a>
          <LanguageSelector className="font-semibold text-md leading-sm text-gray-700" currentLang={language} onChange={onChangeLang} />
          <a
            href={interestHref}
            className="h-[40px] bg-[#05a8fd] w-fit text-[#FFFFFF] text-md leading-sm font-button font-semibold rounded-m hover:bg-[#0497E4] hover:no-underline active:bg-[#0686C8] px-[16px] py-[10px]">
            {t('talk_to_expert.capitalize', {})}
          </a>
        </div>
      </div>
    </nav>
  );
}
